import {
    Component,
    ContentChildren,
    QueryList,
    AfterContentInit,
    ViewChild,
    ComponentFactoryResolver,
    ViewContainerRef,
    EventEmitter,
    Output
  } from '@angular/core';
  
  import { DynamicTabsDirective } from './dynamic-tabs.directive';
  import { TabComponentAutopass } from './tab.componentAuotpass';
  
  @Component({
    selector: 'my-tabsautopass',
    template: `

      <ul class="nav nav-tabs">
      
        <li class="new-tabs" *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
          <span style="cursor: pointer;">{{tab.title}}</span>
        </li>

        <!-- dynamic tabs -->
        <li class="new-tabs"  *ngFor="let tab of dynamicTabs" (click)="selectTab(tab)" [class.active]="tab.active">
          <span>{{tab.dataContext.TabTitle}} <span *ngIf="tab.isCloseable" (click)="closeTab(tab)"><i class="mdi mdi-close-box"></i></span></span>
        </li> 
        
        <!-- <span class="tab-close" *ngIf="dynamicTabs.length > 0" (click)="closeAll()">CLOSE ALL</span>-->

      </ul>

      <ng-content></ng-content>

      <ng-template dynamic-tabs #container></ng-template>
    `,
    styleUrls: ['./tabs.component.scss']
  })
  export class TabsComponentAutopass implements AfterContentInit {

    dynamicTabs: TabComponentAutopass[] = [];
  
    @ContentChildren(TabComponentAutopass) tabs: QueryList<TabComponentAutopass>;
  
    @ViewChild(DynamicTabsDirective, { static: false }) dynamicTabPlaceholder: DynamicTabsDirective;

    @Output() closeAllTabsEmit = new EventEmitter();
    /*
      Alternative approach of using an anchor directive
      would be to simply get hold of a template variable
      as follows
    */
    // @ViewChild('container', {read: ViewContainerRef}) dynamicTabPlaceholder;
  
    constructor(private _componentFactoryResolver: ComponentFactoryResolver) {}
  
    // contentChildren are set
    ngAfterContentInit() {
      // get all active tabs
      const activeTabs = this.tabs.filter(tab => tab.active);
      // if there is no active tab set, activate the first
      if (activeTabs.length === 0) {
        this.selectTab(this.tabs.last);
      }
    }
  
    openTab(title: string, template, data, isCloseable = false) {
      // get a component factory for our TabComponent
      const componentFactory = this._componentFactoryResolver.resolveComponentFactory(
        TabComponentAutopass
      );
  
      //check if tab already exist then open it
      var found = false;
      this.dynamicTabs.forEach((value,index) => {
        if(value.dataContext.TabTitle  == title){
          this.selectTab(this.dynamicTabs[index]);
          found = true;
        }
      });
 
      if(found){return;}
      // fetch the view container reference from our anchor directive
      const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
  
      // alternatively...
      // let viewContainerRef = this.dynamicTabPlaceholder;
  
      // create a component instance
      const componentRef = viewContainerRef.createComponent(componentFactory);
  
      // set the according properties on our component instance
      const instance: TabComponentAutopass = componentRef.instance as TabComponentAutopass;
      
      instance.template = template;
      instance.dataContext = data;
      instance.dataContext.TabTitle = title;
      instance.title =  instance.dataContext.TabTitle;
      instance.isCloseable = isCloseable;
      // remember the dynamic component for rendering the
      // tab navigation headers
      this.dynamicTabs.push(componentRef.instance as TabComponentAutopass);
  
      // set it active
      this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
    }
  
    selectTab(tab: TabComponentAutopass) {
      // deactivate all tabs
      this.tabs.toArray().forEach(tab => (tab.active = false));
      this.dynamicTabs.forEach(tab => (tab.active = false));
      // activate the tab the user has clicked on.
      tab.active = true;
    }

    //note there is no template being used yet here.
    //we assume that the template exist in html first
    selectTabByTitle(title){
      this.tabs.toArray().forEach((item) => {
        if(item.title == title){
          this.selectTab(item);
          return;
        };
      })
    }
  
    closeTab(tab: TabComponentAutopass) {
      for (let i = 0; i < this.dynamicTabs.length; i++) {
        if (this.dynamicTabs[i] === tab) {
          // remove the tab from our array
          this.dynamicTabs.splice(i, 1);
  
          // destroy our dynamically created component again
          let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
          // let viewContainerRef = this.dynamicTabPlaceholder;
          viewContainerRef.remove(i);  
          // set tab index to 1st one
          this.selectTab(this.tabs.last);
          break;
        }
      }
    }
  
    closeActiveTab() {
      const activeTabs = this.dynamicTabs.filter(tab => tab.active);
      if (activeTabs.length > 0) {
        // close the 1st active tab (should only be one at a time)
        this.closeTab(activeTabs[0]);
      }
    }

    closeAll(){

      this.closeAllTabsEmit.emit(true);

      var tabLength = Number(this.dynamicTabs.length);
      for (let i = 0; i < tabLength; i++) {
          this.dynamicTabs.splice(i, 1);
          let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
          viewContainerRef.remove(i);  
          // set tab index to 1st one
          this.selectTab(this.tabs.last);
          break;
        // }
      }
      this.dynamicTabs = [];
      this.tabs.toArray().forEach(tab => (tab.active = false));
      this.selectTab(this.tabs.first);     
    }

    showFilterList(){
      var tabLength = Number(this.dynamicTabs.length);
      for (let i = 0; i < tabLength; i++) {
          this.dynamicTabs.splice(i, 1);
          let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
          viewContainerRef.remove(i);
      }
      // this.selectTab(this.tabs.first);
    }
  }
  